import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrrows-pup",
  "use": "icon-arrrows-pup-usage",
  "viewBox": "0 0 18 29",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 29\" id=\"icon-arrrows-pup\">\r\n  <defs>\r\n    <style>\r\n      #icon-arrrows-pup .cls-1 {\r\n        fill: #e93ca7;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-arrrows-pup_形状_6\" data-name=\"形状 6\" class=\"cls-1\" d=\"M1295.43,646V629.466h6.56l-9-12.477L1284,629.466h6.56V646h4.87Z\" transform=\"translate(-1284 -617)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/arrrows-pup.svg
// module id = 6ak/
// module chunks = 127